import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
export function getUsersSeatsUrl() {
  return `${getFullUrl('app')}/settings/${PortalIdParser.get()}/users/seats`;
}